import yup from 'src/libraries/validator.library';

export const CNDAPIShape = {
  JobId: yup.string().nullable(),
  WorkOrders: yup.array().of(yup.string()).nullable(),
  District: yup.string().nullable(),
  Company: yup.string().nullable(),
  TaskType: yup.string().nullable(),
  StartDate: yup.string().nullable(),
};

export const CNDAPISchema = yup
  .object()
  .shape({
    cndAPIjobId: yup.number(),
    ...CNDAPIShape,
  })
  .defined();

export const CNDAPIFormSchema = yup
  .object()
  .shape({
    ...CNDAPIShape,
  })
  .defined();

export const CNDAPIResponsePayloadSchema = yup
  .object({
    cndAPI: yup
      .object({
        cndAPIjobId: yup.number(),
        ...CNDAPIShape,
      })
      .defined(),
  })
  .defined();

export const CNDAPICallAuditDetailsFormSchema = yup
  .object()
  .shape({
    payload: yup.mixed().required(),
    response: yup.mixed().nullable(),
    apiResponseStatus: yup.string().required(),
     requestId: yup.number().required(),
  })
  .defined();

// Schema for the internal proxy response (server/cndApiCall).
// The proxy forwards NTLM and returns whatever the external CND API sends back,
// so we accept any shape and pass it through for audit logging.
export const CNDAPIProxyResponseSchema = yup.mixed().defined();

export type ICNDAPI = yup.InferType<typeof CNDAPISchema>;
// export type ICNDAPIList = yup.InferType<typeof CNDAPIListSchema>;
export type ICNDAPIForm = yup.InferType<typeof CNDAPIFormSchema>;
export type ICNDAPIAuditCallDetailsForm = yup.InferType<
  typeof CNDAPICallAuditDetailsFormSchema
>;
